import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { unshareGroupReservations } from '../../../services/groupsService'
import { GroupContext } from '../GroupContextProvider'

export default function UnshareGroupReservationsDialog({ checkedRanIds, refetchReservations, ...overlay }) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const { currentGroupData } = useContext(GroupContext)
  const reservationIds = formatCheckedRanIds()

  const confirmBtnOnClick = async () => {
    try {
      overlay.close()
      await unshareGroupReservations(currentGroupData.id, reservationIds.replace(/ /g, ''))
      window.scrollTo({ top: 0, insetInlineStart: 0, behavior: 'smooth' })
      refetchReservations()
    } catch (err) {
      error(
        checkedRanIds.length > 1
          ? t('groups.errors.unsharingReservations', {
              defaultValue: `Error unsharing reservations: ${err.message || ''}`,
              message: err.message || '',
            })
          : t('groups.errors.unsharingReservation', {
              defaultValue: `Error unsharing reservation: ${err.message || ''}`,
              message: err.message || '',
            }),
        err
      )
    }
  }

  function formatCheckedRanIds() {
    let formattedCheckedRanIds = ''
    checkedRanIds.forEach((ranId) => {
      formattedCheckedRanIds += `${ranId}, `
    })
    return formattedCheckedRanIds.slice(0, -2)
  }

  return (
    <DialogOverlay {...overlay} title={t('group.reservations.dialogOverlay.unshare.heading', 'Unshare Reservations')}>
      <>
        <Paragraph size="sm">
          {checkedRanIds.length > 1
            ? t(
                'group.reservations.dialogOverlay.unshare.body.multipleReservations',
                'Are you sure you want to unshare these reservations?'
              )
            : t(
                'group.reservations.dialogOverlay.unshare.body.singleReservation',
                'Are you sure you want to unshare this reservation?'
              )}
        </Paragraph>
        <Paragraph size="sm">{reservationIds}</Paragraph>
      </>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={confirmBtnOnClick}>
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button emphasis="medium" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
